import { connect } from "react-redux";
import { Actions as ADVENTCALENDARACTIONS } from "../../store/actions/adventCalendarActions";
import { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ShoppingCartIcon } from "@heroicons/react/24/outline";
import Select from "react-select";
import { GiftIcon } from "@heroicons/react/20/solid";
import { GiftIcon as GiftIconOutline } from "@heroicons/react/24/outline";
import Vimeo from "@u-wave/react-vimeo";
import QuizComponent from "components/QuizComponent";
import LoginRegister from "./LoginRegister";

import {
	FacebookShareButton,
	FacebookIcon,
	FacebookMessengerShareButton,
	FacebookMessengerIcon,
	TwitterShareButton,
	TwitterIcon,
	LinkedinShareButton,
	LinkedinIcon,
	WhatsappShareButton,
	WhatsappIcon,
} from "react-share";

import giftboxLid from "../../assets/images/adventcalendar/giftbox-lid.png";
import giftboxOpenFront from "../../assets/images/adventcalendar/gift-box-open-front.png";
import giftboxOpenBack from "../../assets/images/adventcalendar/gift-box-open-back.png";
import majorCherryTomatoes from "../../assets/images/adventcalendar/major-cherry-tomatoes.png";

import giftboxOpen from "../../assets/images/adventcalendar/giftbox-open.png";
import _ from "lodash";
import {formatDistance} from "date-fns";

const questions = [
	{
		question: "Which of these best describes you?",
		type: "chooseOne",
		options: [
			{
			  value: "Student",
			  // setFilter: {student: true}
			},
			{
			  value: "Employee",
			  // setFilter: {employee: true}
			},
			{
			  value: "Self Employed",
			  // setFilter: {employer: true}
			},
			{
			  value: "Accountant",
			  // setFilter: {employer: true}
			},
			{
			  value: "HR Manager",
			  // setFilter: {employer: false}
			},
			{
			  value: "Employer",
			  // setFilter: {employer: false}
			},
		  ]
	},
	// {
	//   question: 'Do your payslips contain all the required information?',
	//   type: 'chooseMany',
	// 	filter: {employer: true},
	// 	options: [
	// 		"Yes",
	// 		"No",
	// 		"I don't know",
	// 		"I don't do Payroll",
	// 	],
	// },
	{
	  question: "From what you learnt in the video, is your payslip correct?",
	  type: 'chooseMany',
		// filter: {employee: true},
		options: [
			"Yes",
			"No",
			"I don't know"
		],
	},
	// {
	//   question: 'Which of these do you relate to most?',
	//   type: 'chooseMany',
	//   filter: {inhouse: true},
	//   options: [
	//     "I take too long to get payroll done",
	//     "I’m afraid of making mistakes in my payroll",
	//     "Our Staff do not understand their payslips",
	//     "We're overwhelmed with Staff Queries after payroll",
	//   ]
	// },
	// {
	//   question: 'Which of these do you relate to most?',
	//   type: 'chooseMany',
	//   filter: {inhouse: false},
	//   options: [
	//     "Our Payroll takes too long",
	//     "Our payslips are missing leave and other required items",
	//     "It's a struggle to obtain payslips and send them to staff",
	//     "Our service provider is getting expensive",
	//   ]
	// },
	// {
	//   question: "What's the nature of the business?",
	//   type: 'chooseOne',
	//   options: [
	//     "We work in retail or food service",
	//     "We work in an office ",
	//     "Construction business, field or factory settings",
	//   ]
	// }
];

function CalendarModal({
   setCalendarModal,
   calendarModalOpen,
   saveUserGift,
   boxNumber,
   answers,
   item,
   location,
	loggedIn
}) {
	const currentPageURL = "https://www.buddy.hr/advent-calendar";
	const [secondsWatched, setSecondsWatched] = useState(0);
	const [timeLeft, setTimeLeft] = useState(0);
	const [completed, setCompleted] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);

	// is today before if date is before 1st December 2023
	const isBefore = new Date() < new Date(2023, 11, 1);

	return (
		<Transition.Root
			show={calendarModalOpen}
			as={Fragment}
		>
			<Dialog
				as="div"
				className="fixed z-50"
				onClose={() => {
					setCalendarModal(false);
					setCurrentPage(1);
					setCompleted(false);
					setTimeLeft(0);
				}}
			>
				<div className="fixed inset-0 z-50 w-screen overflow-y-auto">
					<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 overflow-hidden">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0"
							enterTo="opacity-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
						</Transition.Child>

						<span
							className="hidden sm:inline-block sm:align-middle sm:h-screen"
							aria-hidden="true"
						>
							&#8203;
						</span>
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						>
							<div className="inline-block align-bottom rounded-lg text-left transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full min-w-full md:min-w-fit ">
								{/* <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <GiftIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                                Advent Calendar Reward
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    test
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

								{
									isBefore &&
									(!loggedIn ?
										<LoginRegister headerText={"Sign in to Play"}/> :
											<div
												className={`mx-auto sm:w-full sm:max-w-md`}
											>
												<div
													className={`bg-white py-8 px-4 rounded-md sm:rounded-lg sm:px-10`}
												>
													<div className="text-center text-4xl font-advent">{formatDistance(new Date(), new Date(2023, 11, 1), { addSuffix: false })} to start playing</div>
													<div className="mt-5 text-center">You can open your first box on 1st December. <br/> After that come back daily to open another box, so we can maximise the donations to the Food bank. </div>
												</div>
											</div>
									)
								}

								{!isBefore && currentPage == 1 && (
									<div className="bg-gray-50 px-4 py-3">
										<h1 className="text-gray-900 text-3xl mb-2">Payslips</h1>
										<p className="text-gray-900 text-sm mb-2">Watch this short video to learn about payslips before you donate your gift.</p>
										<div className="col-span-10 lg:col-span-7">
											<figure className="bg-black relative">
												<Vimeo
													video={890220722}
													responsive={true}
													showTitle={false}
													showByline={false}
													showPortrait={false}
													autoplay={false}
													onTimeUpdate={(e) => {
														setTimeLeft(Math.round(e.duration - secondsWatched));
														//if(e.seconds > secondsWatched && e.seconds-secondsWatched <= 0.350) // If new duration is larger by < 350ms, update seconds watched
														setSecondsWatched(e.seconds);
														//else if(e.seconds > secondsWatched && e.seconds-secondsWatched > 0.350) // If new duration is larger by > 350ms, Display warning
														//console.log("Uh oh! Seems like you skipped through the video. Progress will not be counted.");
														if (secondsWatched / e.duration >= 0.975)
															// Check if last valid percentage is over 97.5% & set completed true
															setCompleted(true);
													}}
												/>
											</figure>
										</div>
										<div className="flex flex-col items-center">
											<button
												disabled={!completed}
												className="bg-green-500 hover:bg-green-700 disabled:bg-gray-500 text-white font-bold py-2 px-4 rounded mt-3"
												onClick={() => setCurrentPage(2)}
											>
												{ !completed ? `Watch Video` : `Next` }
											</button>
											{/*<p>{timeLeft} seconds</p>*/}
										</div>
									</div>
								)}
								{!isBefore && currentPage == 2 && loggedIn && (
									<div className="bg-gray-50 px-4 py-3">
										<QuizComponent
											questions={questions}
											onLastAnswer={() => {
												setCurrentPage(3);
												saveUserGift({itemId: item.id, boxNumber:boxNumber-1, location, answers})
											}}
											finishQuizText={
												<span>
													Open the Gift{" "}
													<GiftIconOutline className="ml-1 mb-1 w-6 h-6 inline-block" />
												</span>
											}
										/>
									</div>
								)}
								{!isBefore && currentPage == 2 && !loggedIn && (
									<LoginRegister headerText={"Sign in to donate"}/>
								)}
								{!isBefore && currentPage == 3 && (
									<div className="px-4 py-3 spot-black-background pb-16 sm:pb-3">
										<div style={{
											/*transform: "scale(75%) translateY(10%)" *!/*/
											width: "80%",
											maxWidth: "600px",
											margin: "auto",
										}}>
											<div
												className="removeLid"
												style={{
													width: "50%",
													margin: "auto",
													position: "absolute",
													top: "-30%",
													left: "50%",
													transform: "translateX(-50%)",
													zIndex: 100,
												}}
											>
												<img
													src={giftboxLid}
													className="shake shake-constant"
												/>
											</div>
											<div className="relative reveal-container">
												<div
													className="absolute overflow-y-hidden reveal-container-wrapper"
													style={{ bottom: "25%", width: "200%", transform: "translateX(-25%)" }}
												>
													<div
														className="reveal"
														style={{
															transform: "translateY(50%)",
															maxWidth: "35%",
															margin: 'auto'
														}}
													>
														<div
															className="absolute"
															style={{
																margin: "auto",
																left: "50%",
																top: "50%",
																transform: "translate(-50%,-50%)",
																zIndex: "-1",
															}}
														>
															<div className="luminaire">
																<div className="luminaire-before" />
																<div className="luminaire-after" />
															</div>
														</div>
														<img
															src={`https://s3.eu-central-1.amazonaws.com/downloads.buddy.hr/adventCalendar/items/${item.id}.png`}
															style={{
																margin: "auto",
															}}
														/>
													</div>
												</div>
												<img
													src={giftboxOpenFront}
													style={{
														position: "absolute",
													}}
												/>

												<img
													src={giftboxOpenBack}
													className="w-full h-full"
												/>
											</div>
										</div>

										<div className="mt-10 w-full h-auto flex flex-wrap justify-center gap-4 revealBottom">
											<h1 className="text-xl md:text-2xl font-advent drop-shadow-xl text-white">Double the Joy by Sharing the Magic!</h1>
										</div>

										<div className="mt-5 w-full h-auto flex flex-wrap justify-center gap-4 revealBottom">
											<FacebookShareButton
												url={currentPageURL}
												hashtag="#MakingPayrollAboutPeople"
											>
												<FacebookIcon size={32} round={true} />
											</FacebookShareButton>

											<FacebookMessengerShareButton
												appId="2116278978716420"
												url={currentPageURL}
											>
												<FacebookMessengerIcon size={32} round={true} />
											</FacebookMessengerShareButton>

											<TwitterShareButton
												title="Check out this advent calendar: "
												url={currentPageURL}
											>
												<TwitterIcon size={32} round={true} />
											</TwitterShareButton>

											<LinkedinShareButton
												summary="Check out this advent calendar: "
												url={currentPageURL}
											>
												<LinkedinIcon size={32} round={true} />
											</LinkedinShareButton>

											<WhatsappShareButton
												title="Check out Buddy's advent calendar:"
												url={currentPageURL}
											>
												<WhatsappIcon size={32} round={true} />
											</WhatsappShareButton>
										</div>
									</div>
								)}
							</div>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	);
}

const mapStateToProps = (state) => {
	return {
		calendarModalOpen: typeof state.adventCalendar.modal == "number",
		boxNumber: state.adventCalendar.modal || null,
		answers: state.quiz,
		item: state.adventCalendar.myGifts?.find((g)=> g.boxNumber == state.adventCalendar.modal) || _.shuffle(state.adventCalendar.items)[0],
		location: state.adventCalendar?.location,
		loggedIn: !!state.my.profile?.email,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setCalendarModal: (value) => dispatch(ADVENTCALENDARACTIONS.setCalendarModal(value)),
	saveUserGift: (value) => dispatch(ADVENTCALENDARACTIONS.saveUserGift(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarModal);
